import { Predicate } from './predicate';
import { SelectorPredicate } from './selector-predicate';

export function createPredicateView(options) {
  const koModel = options.ko_model;

  if (!koModel || !koModel.metadata()) {
    throw new TypeError('wrong ko_model info passed');
  }

  switch (koModel.metadata().type) {
    case 'id':
      return new SelectorPredicate(options);

    default:
      return new Predicate(options);
  }
}
